// extracted by mini-css-extract-plugin
export default {"sub_box":"TemperatureStatus_sub_box__cpfve","subtitle":"TemperatureStatus_subtitle__UBmWg"};